//Escuchar QS de respuesta de vinculacion. Si viene QS llamar a endpoint de api y finalizar proceso (validar credenciales que llegan por QS). Finalmente redireccionar a pantalla de edicion de perfilde usuario.

//Escuchar QS de navegacion entre sistemas. Si viene QS llamar a endpoint para ejecutar proceso de validacion (Ultima accion es hacer un login de usuario y almacenar la cookie).
import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { encryptBase64, getAuth, getExpAuth } from "../common/Helpers";
import { WEB_AUTH_URL, WEB_CORE_URL } from "../configurations/paths.config";
import { PARAM_NAME_PW } from "../configurations/staticTypes.config";
import { useValidateUserExternalHash } from "../hooks/useOfProfile";
import PropTypes from 'prop-types';

function SSOListener(props) {
    const { t } = useTranslation();

    const { user: currentAuth } = useSelector((state) => state.auth);

    const loginFrom = new URLSearchParams(props.location.search).get('lf');
    const hash = new URLSearchParams(props.location.search).get('scplus');
    const result = new URLSearchParams(props.location.search).get('scresult');
    const idOp = new URLSearchParams(props.location.search).get('sckey');
    
    const skh = new URLSearchParams(props.location.search).get('skh');

    const [status, setStatus] = useState(null);
    const [urlRedirect, setUrlRedirect] = useState(null);
    const [error, setError] = useState(false);
    
    useValidateUserExternalHash(loginFrom, hash, result, idOp, status, setStatus, skh, setUrlRedirect, currentAuth)

    if (urlRedirect !== null) {
        setTimeout(async () => {
            if(urlRedirect === "/#") {
                const tkresponse = await getExpAuth();
                let stringToBase64 = encryptBase64(tkresponse.data.data, PARAM_NAME_PW);
                window.location.href = `${WEB_CORE_URL}/login?stats=success&tk=${encodeURIComponent(stringToBase64)}&redirectback=true`
            }
            else if(urlRedirect === "/|") {
                const tkresponse = await getExpAuth();
                let stringToBase64 = encryptBase64(tkresponse.data.data, PARAM_NAME_PW);
                window.location.href = `${WEB_CORE_URL}/login?stats=success&tk=${encodeURIComponent(stringToBase64)}`
            }
            else if (urlRedirect === "Error") {
                window.sessionStorage.setItem("legacyintegrationerror", "1")
                window.location.href = `${WEB_AUTH_URL}`
            }
            else {
                window.location.href = `${WEB_AUTH_URL}${urlRedirect}`
            }
        }, 500);
    }

    return (
        <Card>
            <Card.Body>
                { t('data-lang-msg-redirect') }
            </Card.Body>
        </Card>
    );
}
SSOListener.propTypes = {
    location: PropTypes.object.isRequired,
};
export default SSOListener;